jQuery(document).ready(function ($) {
    $('.faq-accordion').each(function () {
        const $accordion = $(this);

        $accordion.find('.faq-accordion__item').each(function () {
            const $item = $(this);
            const $question = $item.find('.faq-accordion__question');
            const $answer = $item.find('.faq-accordion__answer');

            if (!$question.length || !$answer.length) {
                return;
            }

            if ($item.prop('open')) {
                $answer.css('height', $answer[0].scrollHeight + 'px');
            }

            $question.on('click', function (event) {
                event.preventDefault();

                if ($item.prop('open')) {
                    closeItem($item, $answer);
                } else {
                    openItem($item, $answer);
                }
            });
        });
    });

    function openItem($item, $answer) {
        $answer.stop(true, true);

        $item.prop('open', true);

        $answer.css('height', '0px');

        requestAnimationFrame(function () {
            $answer.css('height', $answer[0].scrollHeight + 'px');
        });

        $answer.one('transitionend', function (event) {
            if (event.originalEvent.propertyName !== 'height') {
                return;
            }

            $answer.css('height', 'auto');
        });
    }

    function closeItem($item, $answer) {
        $answer.stop(true, true);
        $answer.css('height', $answer[0].scrollHeight + 'px');

        requestAnimationFrame(function () {
            $answer.css('height', '0px');
        });

        $answer.one('transitionend', function (event) {
            if (event.originalEvent.propertyName !== 'height') {
                return;
            }

            $item.prop('open', false);
        });
    }
});